import React from 'react';

const WalletIcon = () => (
  <svg width="40" height="37" viewBox="0 0 155 142" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      y="44.2117"
      width="126.642"
      height="96.7407"
      rx="13.0206"
      transform="rotate(-20.4327 0 44.2117)"
      fill="#278900"
    />
    <rect
      x="10.6518"
      y="37.5456"
      width="130.291"
      height="96.7407"
      rx="13.0206"
      transform="rotate(-8.80578 10.6518 37.5456)"
      fill="#37C100"
    />
    <rect x="1.56046" y="34.3296" width="152.923" height="107.67" rx="17.3608" fill="#123E00" />
    <path
      d="M14.8242 81.0556C14.8242 78.9493 16.5584 77.2417 18.6976 77.2417H25.4405C27.5798 77.2417 29.314 78.9493 29.314 81.0556V87.6948C29.314 89.8011 27.5798 91.5086 25.4405 91.5086H18.6976C16.5584 91.5086 14.8242 89.8011 14.8242 87.6948V81.0556Z"
      fill="#37C100"
    />
    <path
      d="M14.8242 98.8892C14.8242 96.7829 16.5584 95.0753 18.6976 95.0753H25.4405C27.5798 95.0753 29.314 96.7829 29.314 98.8892V105.528C29.314 107.635 27.5798 109.342 25.4405 109.342H18.6976C16.5584 109.342 14.8242 107.635 14.8242 105.528V98.8892Z"
      fill="#37C100"
    />
    <path
      d="M14.8242 116.723C14.8242 114.616 16.5584 112.909 18.6976 112.909H25.4405C27.5798 112.909 29.314 114.616 29.314 116.723V123.362C29.314 125.468 27.5798 127.176 25.4405 127.176H18.6976C16.5584 127.176 14.8242 125.468 14.8242 123.362V116.723Z"
      fill="#37C100"
    />
    <path
      d="M32.9364 81.0556C32.9364 78.9493 34.6706 77.2417 36.8099 77.2417H43.5528C45.692 77.2417 47.4262 78.9493 47.4262 81.0556V87.6948C47.4262 89.8011 45.692 91.5086 43.5528 91.5086H36.8099C34.6706 91.5086 32.9364 89.8011 32.9364 87.6948V81.0556Z"
      fill="#37C100"
    />
    <path
      d="M32.9364 98.8892C32.9364 96.7829 34.6706 95.0753 36.8099 95.0753H43.5528C45.692 95.0753 47.4262 96.7829 47.4262 98.8892V105.528C47.4262 107.635 45.692 109.342 43.5528 109.342H36.8099C34.6706 109.342 32.9364 107.635 32.9364 105.528V98.8892Z"
      fill="#37C100"
    />
    <path
      d="M32.9364 116.723C32.9364 114.616 34.6706 112.909 36.8099 112.909H43.5528C45.692 112.909 47.4262 114.616 47.4262 116.723V123.362C47.4262 125.468 45.692 127.176 43.5528 127.176H36.8099C34.6706 127.176 32.9364 125.468 32.9364 123.362V116.723Z"
      fill="#37C100"
    />
    <path
      d="M51.0487 81.0556C51.0487 78.9493 52.7829 77.2417 54.9221 77.2417H61.665C63.8043 77.2417 65.5385 78.9493 65.5385 81.0556V87.6948C65.5385 89.8011 63.8043 91.5086 61.665 91.5086H54.9221C52.7829 91.5086 51.0487 89.8011 51.0487 87.6948V81.0556Z"
      fill="#37C100"
    />
    <path
      d="M51.0487 98.8892C51.0487 96.7829 52.7829 95.0754 54.9221 95.0754H61.665C63.8043 95.0754 65.5385 96.7829 65.5385 98.8892V105.528C65.5385 107.635 63.8043 109.342 61.665 109.342H54.9221C52.7829 109.342 51.0487 107.635 51.0487 105.528V98.8892Z"
      fill="#37C100"
    />
    <path
      d="M51.0487 116.723C51.0487 114.616 52.7829 112.909 54.9221 112.909H61.665C63.8043 112.909 65.5385 114.616 65.5385 116.723V123.362C65.5385 125.468 63.8043 127.176 61.665 127.176H54.9221C52.7829 127.176 51.0487 125.468 51.0487 123.362V116.723Z"
      fill="#37C100"
    />
  </svg>
);

export default WalletIcon;
